// src/api/expense.api.ts
import { get, post, put, del } from './client';

export const expenseApi = {
  getAllExpenses: (params?: {
    page?: number;
    limit?: number;
    category?: string;
    startDate?: string;
    endDate?: string;
    search?: string;
    sortBy?: string;
    sortOrder?: string;
  }) => get('/expenses', { params }),

  getExpenseById: (id: string) => get(`/expenses/${id}`),

  createExpense: (data: {
    category: string;
    description: string;
    amount: number;
    date: string;
    notes?: string;
  }) => post('/expenses', data),

  updateExpense: (id: string, data: {
    category?: string;
    description?: string;
    amount?: number;
    date?: string;
    notes?: string;
  }) => put(`/expenses/${id}`, data),

  deleteExpense: (id: string) => del(`/expenses/${id}`),

  getExpenseSummary: (params?: { startDate?: string; endDate?: string }) =>
    get('/expenses/summary', { params }),
};
